export const serializeSkillGroup = skillGroup => ({
  id: String(skillGroup.id),
  title: skillGroup.title,
});

export const serializeSkillGroups = skillGroups =>
  skillGroups.map(skillGroup => serializeSkillGroup(skillGroup));
